export default "__VITE_ASSET__BGTIyFEE__"